var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#F9F9FB"}},[_c('Mainlayout'),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_c('calendar-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }